document.addEventListener('DOMContentLoaded', function() {

  // Handle letter clicks (not "All")
  document.querySelectorAll('.brands-nav a:not(.all)').forEach(link => {
    link.addEventListener('click', function(event) {
      const showme = this.dataset.brandtarget;

      document.querySelectorAll('.brand-container').forEach(container => {
        if (container.classList.contains(showme)) {
          slideDown(container);
        } else {
          slideUp(container);
        }
      });
    });
  });

  // Handle "All" click
  document.querySelectorAll('.brands-nav a.all').forEach(link => {
    link.addEventListener('click', function() {
      document.querySelectorAll('.brand-container').forEach(container => {
        slideDown(container);
      });
    });
  });

  // --- Slide helpers ---
  function slideUp(element) {
    element.style.transition = 'height 0.3s ease, opacity 0.3s ease';
    element.style.overflow = 'hidden';
    element.style.height = element.scrollHeight + 'px';
    requestAnimationFrame(() => {
      element.style.height = '0';
      element.style.opacity = '0';
    });
    setTimeout(() => { element.style.display = 'none'; }, 300);
  }

  function slideDown(element) {
    element.style.display = 'flex';
    const height = element.scrollHeight + 'px';
    element.style.height = '0';
    element.style.opacity = '0';
    element.style.transition = 'height 0.3s ease, opacity 0.3s ease';
    requestAnimationFrame(() => {
      element.style.height = height;
      element.style.opacity = '1';
    });
    setTimeout(() => {
      element.style.height = '';
      element.style.overflow = '';
    }, 300);
  }
});
